export default "__VITE_ASSET__0sLlAIMX__"